import { useTranslation } from "react-i18next";
import {
  convertToCommaSeparatedNumberwithoutDecimal,
  formatAmountUnitDecimalPlace,
  formatAmountWithCommas,
} from "@/utility/common";
import { useSelector } from "react-redux";

const amountCellRenderers = (field: string) => (params: any) => {
  const decimalPlace = params.decimalPlace;
  const paymentUnitName = params.accountUnitName;
  if (params.node.rowPinned) {
    let tableData = params?.api?.rowModel?.rowsToDisplay || [];
    let totalAmount: any = null;
    if (tableData.length > 0) {
      tableData.forEach((ele: any) => {
        if(ele?.data?.[field] === undefined || ele?.data?.[field] === null) {
          return;
        }
        totalAmount = totalAmount + ele?.data?.[field];
        totalAmount = Number(totalAmount.toFixed(decimalPlace || 8));
      });
    }
    if (decimalPlace) {
      totalAmount = formatAmountWithCommas(totalAmount, decimalPlace);
    } else {
      totalAmount = convertToCommaSeparatedNumberwithoutDecimal(totalAmount);
    }
    if (paymentUnitName) {
      totalAmount += ` ${paymentUnitName}`;
    }
    return totalAmount;
  }
  const amount = params.data[field];
  let formattedAmount = amount;
  if (decimalPlace) {
    formattedAmount = formatAmountWithCommas(amount, decimalPlace);
  } else {
    formattedAmount = convertToCommaSeparatedNumberwithoutDecimal(amount);
  }
  if (paymentUnitName) {
    formattedAmount += ` ${paymentUnitName}`;
  }
  return formattedAmount;
};
export const usePaymentSummaryColumnDefs = (
  handleCellClick: (params: any) => void,
  decimalPlace: any,
  unitName: any,
  accountUnitName: any
) => {
  const caseData = useSelector((state: any) => state.case);

  const amountCellRenderer = (field: string) => (params: any) => {
    if (params.node.rowPinned) {
      return "";
    }
    const { defaultUnit } = caseData;
    const decimalPlace = defaultUnit?.decimalPlace;
    const amount = params.data[field];
    const formattedDefaultAmount = formatAmountUnitDecimalPlace(
      amount,
      decimalPlace
    );
    return formattedDefaultAmount !== "-"
      ? `${formattedDefaultAmount} ${defaultUnit?.name}`
      : formattedDefaultAmount;
  };
  const { t } = useTranslation();
  return [
    {
      field: "claimItemReference",
      type: "claimIdType",
      headerName: t(
        "pages.paymentStatus.paymentSummary.tableColumnHeader.claimItemId"
      ),
      flex: 1,
      minWidth: 150,
      sortable: true,
      unSortIcon: true,
      cellClass: "text-bold-underline",
      cellStyle: { cursor: "pointer" },

      onCellClicked: handleCellClick,
    },
    {
      field: "category",
      type: "categoryType",
      headerName: t(
        "pages.paymentStatus.paymentSummary.tableColumnHeader.category"
      ),
      flex: 1,
      minWidth: 150,
      sortable: true,
      unSortIcon: true,
    },
    {
      field: "resolvedAmount",
      type: "resolvedAmountType",
      headerName: t(
        "pages.paymentStatus.paymentSummary.tableColumnHeader.resolvedAmount",
        { unitName: caseData?.defaultUnit?.name }
      ),
      flex: 1,
      minWidth: 150,
      sortable: true,
      unSortIcon: true,
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
      cellRenderer: amountCellRenderer("resolvedAmount"),
    },
    {
      field: "className",
      type: "classNameType",
      headerName: t(
        "pages.paymentStatus.paymentSummary.tableColumnHeader.class"
      ),
      flex: 1,
      minWidth: 150,
      sortable: true,
      unSortIcon: true,
      cellRenderer: (params: any) => {
        return params.data.className || "-";
      },
    },
    {
      field: "entitlementAmount",
      type: "entitlementAmountType",
      headerName: t(
        "pages.paymentStatus.paymentSummary.tableColumnHeader.entitlementAmount"
      ),
      flex: 1,
      minWidth: 250,
      sortable: true,
      unSortIcon: true,
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
      cellRenderer: amountCellRenderers("entitlementAmount"),
      cellRendererParams: { decimalPlace, unitName,accountUnitName },
    },
    {
      field: "priorSettledAmount",
      type: "priorSettledAmountType",
      headerName: t(
        "pages.paymentStatus.paymentSummary.tableColumnHeader.priorSettledAmount"
      ),
      flex: 1,
      minWidth: 250,
      sortable: true,
      unSortIcon: true,
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
      cellRenderer: amountCellRenderers("priorSettledAmount"),
      cellRendererParams: { decimalPlace, unitName,accountUnitName },
    },
    {
      field: "settlementAmount",
      type: "settlementAmountType",
      headerName: t(
        "pages.paymentStatus.paymentSummary.tableColumnHeader.settlementAmount"
      ),
      sortable: true,
      unSortIcon: true,
      flex: 1,
      minWidth: 250,
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
      cellRenderer: amountCellRenderers("settlementAmount"),
      cellRendererParams: { decimalPlace, unitName,accountUnitName },
    },
  ];
};
